import { Box } from "@mui/material";
import { TemplateCategoryChipView } from "./TemplateCategoryChipView";
import { TemplateClientTypeView } from "./TemplateClientTypeView";

export const TemplateFilterSection = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr minmax(auto,18.125rem)",
        marginTop: "20px",
        gap: "20px",
      }}
    >
      <TemplateCategoryChipView />
      <TemplateClientTypeView />
    </Box>
  );
};
